import React from 'react';
import { View } from 'react-native';
import styled from 'styled-components/native';

import { Text } from 'app/src/styles';
import colors from 'app/src/styles/colors';

const Container = styled(View)`
  background-color: ${colors.header};
  padding: 20px;
`;

const SiteTitle = styled(Text)`
  color: white;
  font-size: 22px;
`;

const PublicMenu = () => {
  return (
    <Container>
      <SiteTitle>
        Keeping.Care
      </SiteTitle>
    </Container>
  );
};

export default PublicMenu;
